import React from "react";

export const Footer = () => {
  return (
    <footer className="relative bg-[#060809] border-t border-[var(--border)] py-16" data-testid="site-footer">
      <div className="max-w-6xl mx-auto px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-10">
          <div>
            <img
              src="/assets/logo-white.png"
              alt="The Biohacker Network"
              className="h-8 w-auto"
              data-testid="footer-logo"
            />
            <p className="mt-4 font-display text-sm tracking-[0.3em] text-dim">
              SCIENCE <span className="text-cyan">•</span> SIGNALS <span className="text-emerald">•</span> SYSTEMS
            </p>
          </div>

          <nav className="flex flex-wrap gap-x-8 gap-y-3" data-testid="footer-nav">
            {["Terms", "Privacy", "Membership Terms", "Contact"].map((l) => (
              <a
                key={l}
                href="#"
                className="text-sm text-dim hover:text-white transition-colors"
                data-testid={`footer-link-${l.toLowerCase().replace(/\s+/g, "-")}`}
              >
                {l}
              </a>
            ))}
          </nav>
        </div>

        <div className="divider-line my-10" />

        <p className="text-xs text-[var(--text-faint)] max-w-2xl leading-relaxed">
          Membership benefits, credits, discounts and offers are subject to applicable membership
          terms and availability.
        </p>
        <p className="mt-4 text-xs text-[var(--text-faint)]">
          © {new Date().getFullYear()} The Biohacker Network. All rights reserved.
        </p>
      </div>
    </footer>
  );
};
